angular
	.module 'App.Module.ShopGroup', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'shop_groups',
				url: '/shop_groups',
				abstract: true
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					'entity_search@shop_groups':
						templateUrl: '@app/layout/views/app.entity-tree-search.view.html'
						controller: 'BaseTreeSearchController'
						controllerAs: 'search'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					treeItems: (ShopGroupRepository) ->
						return ShopGroupRepository.getEntities()
				data:
					searchParams:
						repositoryName: 'ShopGroupRepository'
						title: 'general.shop.groups'
					restrict: 'Backoffice.TopMenu.Shops'

			.state 'shop_groups.edit',
				url: '/:id'
				abstract: true
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					shopGroup: (ShopGroupRepository, $stateParams) ->
						return ShopGroupRepository.getEntity($stateParams.id)

					shopsList: (ShopRepository, $stateParams) ->
						if _.isEmpty($stateParams.id)
							return {count: 0, data: []}

						query = ShopRepository.createQuery()
						query.with 'shop_groups'
						query.criteria 'shop_groups.id', '=', $stateParams.id

						return ShopRepository.getEntitiesWithCount query

					productsList: (ProductRepository, $stateParams) ->
						if _.isEmpty($stateParams.id)
							return {count: 0, data: []}

						query = ProductRepository.createQuery()
						query.with 'shop_groups'
						query.criteria 'shop_groups.id', '=', $stateParams.id

						return ProductRepository.getEntitiesWithCount query

			.state 'shop_groups.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'ShopGroupController'
						controllerAs: 'vm'
						templateUrl: '@app/shop-group/shop-group.view.html'
